module.exports = __webpack_public_path__ + "img/category_347.3723244f.jpg";